import { useLocal } from '@/i18n/LocalContext'
import './index.scss'
import CommonModal from '@/components/CommonModal/CommonModal'
import Prop from '@/components/Prop/Prop'
import { lotteryPreview } from '@app/request'
import {
  getDefaultLotteryPreviewData,
  LotteryPreviewData,
} from '@app/store/lottery'
import {
  useState,
  useEffect,
  useCallback,
  useRef,
  useImperativeHandle,
} from 'react'
import appExpose from '@app/expose'
import { useStore } from '@/store'
import { Handler } from 'mitt'
const { emitter } = appExpose
interface rewardPreviewProps {
  open: boolean
  text?: string
  onClose: () => void
  pending?: boolean
}

export default function rewardPreview(props: rewardPreviewProps) {
  const { open, onClose, pending } = Object.assign<
    Partial<rewardPreviewProps>,
    rewardPreviewProps
  >(
    {
      open: false,
      pending: false,
    },
    props
  )
  const [loading, setLoading] = useState(false)
  const { state, dispatch } = useStore()
  const playerId = state.login.userInfo.playerId
  const { $t } = useLocal()

  const [previewData, setPreviewData] = useState<LotteryPreviewData>(
    getDefaultLotteryPreviewData()
  )

  // 获取init数据
  useEffect(() => {
    const handler: Handler<void> = async () => {
      setLoading(true)
      const data = await lotteryPreview(playerId)
      if (data.high.length) {
        setPreviewData({
          high: [...data.high],
          medium: [...data.medium],
          low: [...data.low],
        })
      }

      setLoading(false)
    }
    if (open && !pending) {
      // 判断previewData.high是否有数据，有数据就不请求了
      if (previewData.high.every((item) => item.count === 0)) {
        handler()
      }
    }
    // emitter.on('getBaseData', handler)
    emitter.on('updateLotteryData', handler)
    return () => {
      // emitter.off('getBaseData', handler)
      emitter.off('updateLotteryData', handler)
    }
  }, [playerId, open, previewData])
  return (
    <CommonModal
      type="rewardPreview"
      length="long"
      open={open}
      title={$t('奖励预览')}
      onClose={onClose}
    >
      {[
        <div key="1" className="rewardPreview">
          {loading ? (
            <div key="11" className="__onemt__loader-box">
              <div className="__onemt__loader"></div>
            </div>
          ) : null}
          {previewData.high.length ? (
            <div className="rewardPreview-content high-block">
              <div className="rewardPreview-title">{$t('高级奖池')}</div>
              <div className="rewardPreview-prop-list">
                {previewData.high.map((reward, i) => (
                  <div
                    key={i}
                    className={`rewardPreview-prop q-${reward.quality}`}
                  >
                    {reward.prop.icon ? (
                      <Prop
                        name={reward.prop.name}
                        imgSrc={reward.prop.icon}
                        count={reward.count}
                        get={false}
                        desc={reward.prop.desc}
                        key={reward.prop.key}
                        pkey={reward.prop.key}
                      />
                    ) : null}
                    <div className="coin-info">
                      <i className="coin-icon"></i>
                      <span>{reward.coin}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : null}
          {previewData.medium.length ? (
            <div className="rewardPreview-content medium-block">
              <div className="rewardPreview-title">{$t('中级奖池')}</div>
              <div className="rewardPreview-prop-list">
                {previewData.medium.map((reward, i) => (
                  <div
                    key={i}
                    className={`rewardPreview-prop q-${reward.quality}`}
                  >
                    {reward.prop.icon ? (
                      <Prop
                        name={reward.prop.name}
                        imgSrc={reward.prop.icon}
                        count={reward.count}
                        get={false}
                        desc={reward.prop.desc}
                      />
                    ) : null}
                    <div className="coin-info">
                      <i className="coin-icon"></i>
                      <span>{reward.coin}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : null}
          {previewData.low.length ? (
            <div className="rewardPreview-content low-block">
              <div className="rewardPreview-title">{$t('初级奖池')}</div>
              <div className="rewardPreview-prop-list">
                {previewData.low.map((reward, i) => (
                  <div
                    key={i}
                    className={`rewardPreview-prop q-${reward.quality}`}
                  >
                    {reward.prop.icon ? (
                      <Prop
                        name={reward.prop.name}
                        imgSrc={reward.prop.icon}
                        count={reward.count}
                        get={false}
                        desc={reward.prop.desc}
                      />
                    ) : null}
                    <div className="coin-info">
                      <i className="coin-icon"></i>
                      <span>{reward.coin}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : null}
        </div>,
      ]}
    </CommonModal>
  )
}
